"use client";
import React, { useEffect, useState } from "react";
import confetti from "canvas-confetti";

const NewYear2026 = () => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (isOpen) {
      // Professional confetti burst
      const count = 200;
      const defaults = { origin: { y: 0.7 }, zIndex: 100000 };

      function fire(particleRatio, opts) {
        confetti({
          ...defaults,
          ...opts,
          particleCount: Math.floor(count * particleRatio),
        });
      }

      fire(0.25, { spread: 26, startVelocity: 55 });
      fire(0.2, { spread: 60 });
      fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
      fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
      fire(0.1, { spread: 120, startVelocity: 45 });
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="ny-overlay">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz,wght@0,6..96,400..900;1,6..96,400..900&family=Inter:wght@300;400;700&display=swap');

        .ny-overlay {
          position: fixed;
          inset: 0;
          background: radial-gradient(circle at center, #0a0a0c 0%, #000000 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 99999;
          overflow: hidden;
          font-family: 'Inter', sans-serif;
          perspective: 1000px;
        }

        .ny-content {
          position: relative;
          text-align: center;
          padding: 60px 40px;
          border-radius: 40px;
          background: rgba(255, 255, 255, 0.03);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border: 1px solid rgba(255, 255, 255, 0.1);
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
          max-width: 800px;
          width: 90%;
          animation: slideUp 1.2s cubic-bezier(0.22, 1, 0.36, 1);
        }

        .ny-message {
          color: rgba(255, 255, 255, 0.8);
          font-size: 1.1rem;
          line-height: 1.8;
          margin-bottom: 2rem;
          font-weight: 300;
          letter-spacing: 0.5px;
          font-family: 'Inter', sans-serif;
        }

        .ny-year {
          font-family: 'Bodoni Moda', serif;
          font-size: clamp(6rem, 20vw, 12rem);
          font-weight: 800;
          margin: 0;
          background: linear-gradient(135deg, #fff 0%, #d4af37 40%, #f9e29c 60%, #b8860b 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          filter: drop-shadow(0 10px 20px rgba(184, 134, 11, 0.3));
          letter-spacing: -5px;
          line-height: 0.9;
        }

        .ny-wish {
          color: #d4af37;
          font-size: 1rem;
          letter-spacing: 0.8rem;
          text-transform: uppercase;
          margin-bottom: 3rem;
          font-weight: 700;
          opacity: 0;
          animation: fadeIn 1s ease forwards 0.8s;
        }

        .ny-btn {
          position: relative;
          padding: 18px 45px;
          font-size: 0.9rem;
          font-weight: 700;
          letter-spacing: 2px;
          color: #000;
          background: #ffffff;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
          overflow: hidden;
        }

        .ny-btn:hover {
          background: #d4af37;
          color: #fff;
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(212, 175, 55, 0.3);
        }

        /* Luxury shimmer effect on button */
        .ny-btn::after {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: linear-gradient(45deg, transparent, rgba(255,255,255,0.6), transparent);
          transform: rotate(45deg);
          animation: shimmer 3s infinite;
        }

        @keyframes shimmer {
          0% { left: -100%; }
          100% { left: 100%; }
        }

        @keyframes slideUp {
          from { opacity: 0; transform: translateY(50px) rotateX(10deg); }
          to { opacity: 1; transform: translateY(0) rotateX(0); }
        }

        @keyframes fadeIn {
          to { opacity: 1; }
        }

        .bg-glow {
          position: absolute;
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, rgba(212, 175, 55, 0.15) 0%, transparent 70%);
          border-radius: 50%;
          filter: blur(50px);
          pointer-events: none;
        }
      `}</style>
      {/* Decorative background glows */}
      <div className="bg-glow" style={{ top: "10%", left: "10%" }}></div>
      <div className="bg-glow" style={{ bottom: "10%", right: "10%" }}></div>
      <div className="ny-content">
        <div className="ny-message">
          As we welcome <strong>2026</strong>, we celebrate the memories and
          milestones that shaped us. Growth comes from shared values and the
          courage to move forward with purpose. Let’s rewrite our story with
          passion, perfection, and progress.
        </div>
        <h1 className="ny-year">2026</h1>
        <p className="ny-wish">— Happy New Year —</p>
        <button className="ny-btn" onClick={() => setIsOpen(false)}>
          ENTER TO FEEL NEW EXPERIENCE
        </button>
      </div>
    </div>
  );
};

export default NewYear2026;
